import { GenericFilter } from '@/components/GenericFilter';
import type { ListBrandFilterType, ListBrandFilterTypeWithValues } from '@shelflix/schemas/brand/list';
import { useEffect } from 'react';

export function BrandFilter({ onChange }: { onChange: (filters: ListBrandFilterTypeWithValues) => void }) {
  const options: ListBrandFilterType = {
    search: {
      label: 'Nome',
      fields: ['name'],
    },
    filter: [
      {
        label: 'Status',
        field: { name: 'active', condition: 'equals' },
        items: [
          { text: 'Ativo', value: true },
          { text: 'Inativo', value: false },
        ],
      },
    ],
    sort: {
      label: 'Ordenar por',
      options: [
        { field: 'name', text: 'Alfabética A-Z', direction: 'asc' },
        { field: 'name', text: 'Alfabética Z-A', direction: 'desc' },
      ],
    },
  };

  useEffect(() => {
    onChange({ sort: { field: 'name', direction: 'asc' } });
  }, [onChange]);

  return <GenericFilter options={options} onChange={onChange} />;
}
